<template>
  <adv-button
    class="addtoCart"
    v-on:btn-click="buttonClick"
    :disabled="disabled"
    :productId="this.productId"
    :quantity="this.quantity"
    :href="isRestricted ? 'tel:+302108832688' : null"
    :is-listing="isListing"
    :is-variation-group-master="isVariationGroupMaster"
    :attribute-ids-with-stock="getAttributeIdsWithStock"
    v-html="buttonText"
  >
  </adv-button>
</template>

<script>
import onlineMixin from './mixins/onlineMixin'
import cartButtonMixin from './mixins/cartButtonMixin'
import AdvButton from './presentation/AdvButton'
import { flatten } from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'AdvCartButton',
  components: {
    AdvButton
  },
  mixins: [onlineMixin, cartButtonMixin],
  props: {
    productId: Number,
    quantity: {
      type: Number,
      default: 0
    },
    stock: {
      type: Number,
      default: 1
    },
    unavailable: {
      type: Boolean,
      default: false
    },
    progress: {
      type: Boolean,
      default: false
    },
    cartLimitReached: {
      type: Boolean,
      default: false
    },
    hasAttributes: {
      type: Boolean,
      default: false
    },
    selectedAttributeId: {
      type: Number,
      default: null
    },
    isListing: {
      type: Boolean,
      default: false
    },
    isVariationGroupMaster: {
      type: Boolean,
      default: false
    },
    isRestricted: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      version: '0.0.3'
    }
  },
  computed: {
    ...mapGetters(['getProductById']),
    productData () {
      return this.getProductById(this.productId)
    },
    getAttributeIdsWithStock () {
      return flatten(this.productData.productCodes
        .filter(item => item.productStock > 0)
        .map(item => item.productCodeAttributes))
    }
  },
  methods: {
    buttonClick () {
      if (this.isRestricted) {
        return
      }
      if (this.stock <= 0 && (!this.isListing && !this.isVariationGroupMaster)) {
        this.$emit('btn-click-no-stock')
      } else if (this.isListing && this.isVariationGroupMaster) {
        this.$emit('btn-click-variation-master')
      } else {
        this.$emit('btn-click')
      }
    }
  }
}
</script>
